import { useEffect, useMemo } from 'react';
// oxlint-disable-next-line no-restricted-imports
import { useParams, useRouteError } from 'react-router';
import type { RUMCustomErrorContext } from '@gonfalon/telemetry/types';

import { trackRouteError } from './trackRouteError';

type UseTrackRouteErrorArgs = RUMCustomErrorContext & {
  disableAutoTrack?: boolean;
};

/**
 * Wrapper around `useRouteError` hook that sends the error to Datadog.
 * @returns Route error object
 */
export function useTrackRouteError({
  disableAutoTrack,
  inflightExperiences,
  isCrash,
  metadata,
  owner,
  severity,
  url,
}: UseTrackRouteErrorArgs = {}) {
  const error = useRouteError();
  const routeParams = useParams();
  const trackError = useMemo(
    () => () =>
      trackRouteError(error, { inflightExperiences, isCrash, metadata, owner, severity, url }, { routeParams }),
    [error, inflightExperiences, isCrash, metadata, owner, routeParams, severity, url],
  );

  useEffect(() => {
    if (!disableAutoTrack) {
      trackError();
    }
  }, [disableAutoTrack, trackError]);

  return {
    error,
    trackError,
  };
}
